/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as SystemRouteImport } from './routes/system'
import { Route as StoreRouteImport } from './routes/store'
import { Route as StorageRouteImport } from './routes/storage'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RunWorkloadsRouteImport } from './routes/run-workloads'
import { Route as RunJobRouteImport } from './routes/run-job'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as ProvidersRouteImport } from './routes/providers'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PooledComputeRouteImport } from './routes/pooled-compute'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as OrgRouteImport } from './routes/org'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as EmailVerificationRouteImport } from './routes/email-verification'
import { Route as EarlyAccessRouteImport } from './routes/early-access'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ComputeResourceManagementRouteImport } from './routes/compute-resource-management'
import { Route as AlliancedaoRouteImport } from './routes/alliancedao'
import { Route as AdministratorRouteImport } from './routes/administrator'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdministratorIndexRouteImport } from './routes/administrator.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdministratorWorkspacesRouteImport } from './routes/administrator.workspaces'
import { Route as AdministratorUsersRouteImport } from './routes/administrator.users'
import { Route as AdministratorSettingsRouteImport } from './routes/administrator.settings'
import { Route as AdministratorReportsRouteImport } from './routes/administrator.reports'
import { Route as AdministratorProvidersRouteImport } from './routes/administrator.providers'
import { Route as AdministratorErrorsRouteImport } from './routes/administrator.errors'
import { Route as AdministratorEarlyAccessRouteImport } from './routes/administrator.early-access'
import { Route as AdministratorCreditsRouteImport } from './routes/administrator.credits'
import { Route as AdministratorAuditRouteImport } from './routes/administrator.audit'
import { Route as AdministratorApprovalsRouteImport } from './routes/administrator.approvals'
import { Route as AdministratorAdministratorsRouteImport } from './routes/administrator.administrators'
import { Route as AdminWorkspacesRouteImport } from './routes/admin.workspaces'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminProvidersRouteImport } from './routes/admin.providers'
import { Route as AdminInstancesRouteImport } from './routes/admin.instances'
import { Route as AdminEarlyAccessRouteImport } from './routes/admin.early-access'
import { Route as AdminCreditsRouteImport } from './routes/admin.credits'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminApprovalsRouteImport } from './routes/admin.approvals'
import { Route as AdminAdministratorsRouteImport } from './routes/admin.administrators'

const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRoute = SystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreRoute = StoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRoute = StorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RunWorkloadsRoute = RunWorkloadsRouteImport.update({
  id: '/run-workloads',
  path: '/run-workloads',
  getParentRoute: () => rootRouteImport,
} as any)
const RunJobRoute = RunJobRouteImport.update({
  id: '/run-job',
  path: '/run-job',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvidersRoute = ProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PooledComputeRoute = PooledComputeRouteImport.update({
  id: '/pooled-compute',
  path: '/pooled-compute',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailVerificationRoute = EmailVerificationRouteImport.update({
  id: '/email-verification',
  path: '/email-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const EarlyAccessRoute = EarlyAccessRouteImport.update({
  id: '/early-access',
  path: '/early-access',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ComputeResourceManagementRoute =
  ComputeResourceManagementRouteImport.update({
    id: '/compute-resource-management',
    path: '/compute-resource-management',
    getParentRoute: () => rootRouteImport,
  } as any)
const AlliancedaoRoute = AlliancedaoRouteImport.update({
  id: '/alliancedao',
  path: '/alliancedao',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministratorRoute = AdministratorRouteImport.update({
  id: '/administrator',
  path: '/administrator',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministratorIndexRoute = AdministratorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministratorWorkspacesRoute = AdministratorWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorUsersRoute = AdministratorUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorSettingsRoute = AdministratorSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorReportsRoute = AdministratorReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorProvidersRoute = AdministratorProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorErrorsRoute = AdministratorErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorEarlyAccessRoute =
  AdministratorEarlyAccessRouteImport.update({
    id: '/early-access',
    path: '/early-access',
    getParentRoute: () => AdministratorRoute,
  } as any)
const AdministratorCreditsRoute = AdministratorCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorAuditRoute = AdministratorAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorApprovalsRoute = AdministratorApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AdministratorRoute,
} as any)
const AdministratorAdministratorsRoute =
  AdministratorAdministratorsRouteImport.update({
    id: '/administrators',
    path: '/administrators',
    getParentRoute: () => AdministratorRoute,
  } as any)
const AdminWorkspacesRoute = AdminWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProvidersRoute = AdminProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInstancesRoute = AdminInstancesRouteImport.update({
  id: '/instances',
  path: '/instances',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEarlyAccessRoute = AdminEarlyAccessRouteImport.update({
  id: '/early-access',
  path: '/early-access',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCreditsRoute = AdminCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdministratorsRoute = AdminAdministratorsRouteImport.update({
  id: '/administrators',
  path: '/administrators',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/administrator': typeof AdministratorRouteWithChildren
  '/alliancedao': typeof AlliancedaoRoute
  '/compute-resource-management': typeof ComputeResourceManagementRoute
  '/connect': typeof ConnectRoute
  '/crm': typeof CrmRoute
  '/device': typeof DeviceRoute
  '/early-access': typeof EarlyAccessRoute
  '/email-verification': typeof EmailVerificationRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/org': typeof OrgRoute
  '/password-reset': typeof PasswordResetRoute
  '/pooled-compute': typeof PooledComputeRoute
  '/privacy': typeof PrivacyRoute
  '/providers': typeof ProvidersRoute
  '/request-access': typeof RequestAccessRoute
  '/run-job': typeof RunJobRoute
  '/run-workloads': typeof RunWorkloadsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/storage': typeof StorageRoute
  '/store': typeof StoreRoute
  '/system': typeof SystemRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/wallet': typeof WalletRoute
  '/admin/administrators': typeof AdminAdministratorsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/early-access': typeof AdminEarlyAccessRoute
  '/admin/instances': typeof AdminInstancesRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/administrator/administrators': typeof AdministratorAdministratorsRoute
  '/administrator/approvals': typeof AdministratorApprovalsRoute
  '/administrator/audit': typeof AdministratorAuditRoute
  '/administrator/credits': typeof AdministratorCreditsRoute
  '/administrator/early-access': typeof AdministratorEarlyAccessRoute
  '/administrator/errors': typeof AdministratorErrorsRoute
  '/administrator/providers': typeof AdministratorProvidersRoute
  '/administrator/reports': typeof AdministratorReportsRoute
  '/administrator/settings': typeof AdministratorSettingsRoute
  '/administrator/users': typeof AdministratorUsersRoute
  '/administrator/workspaces': typeof AdministratorWorkspacesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/administrator/': typeof AdministratorIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/alliancedao': typeof AlliancedaoRoute
  '/compute-resource-management': typeof ComputeResourceManagementRoute
  '/connect': typeof ConnectRoute
  '/crm': typeof CrmRoute
  '/device': typeof DeviceRoute
  '/early-access': typeof EarlyAccessRoute
  '/email-verification': typeof EmailVerificationRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/org': typeof OrgRoute
  '/password-reset': typeof PasswordResetRoute
  '/pooled-compute': typeof PooledComputeRoute
  '/privacy': typeof PrivacyRoute
  '/providers': typeof ProvidersRoute
  '/request-access': typeof RequestAccessRoute
  '/run-job': typeof RunJobRoute
  '/run-workloads': typeof RunWorkloadsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/storage': typeof StorageRoute
  '/store': typeof StoreRoute
  '/system': typeof SystemRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/wallet': typeof WalletRoute
  '/admin/administrators': typeof AdminAdministratorsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/early-access': typeof AdminEarlyAccessRoute
  '/admin/instances': typeof AdminInstancesRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/administrator/administrators': typeof AdministratorAdministratorsRoute
  '/administrator/approvals': typeof AdministratorApprovalsRoute
  '/administrator/audit': typeof AdministratorAuditRoute
  '/administrator/credits': typeof AdministratorCreditsRoute
  '/administrator/early-access': typeof AdministratorEarlyAccessRoute
  '/administrator/errors': typeof AdministratorErrorsRoute
  '/administrator/providers': typeof AdministratorProvidersRoute
  '/administrator/reports': typeof AdministratorReportsRoute
  '/administrator/settings': typeof AdministratorSettingsRoute
  '/administrator/users': typeof AdministratorUsersRoute
  '/administrator/workspaces': typeof AdministratorWorkspacesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin': typeof AdminIndexRoute
  '/administrator': typeof AdministratorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/administrator': typeof AdministratorRouteWithChildren
  '/alliancedao': typeof AlliancedaoRoute
  '/compute-resource-management': typeof ComputeResourceManagementRoute
  '/connect': typeof ConnectRoute
  '/crm': typeof CrmRoute
  '/device': typeof DeviceRoute
  '/early-access': typeof EarlyAccessRoute
  '/email-verification': typeof EmailVerificationRoute
  '/finance': typeof FinanceRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/org': typeof OrgRoute
  '/password-reset': typeof PasswordResetRoute
  '/pooled-compute': typeof PooledComputeRoute
  '/privacy': typeof PrivacyRoute
  '/providers': typeof ProvidersRoute
  '/request-access': typeof RequestAccessRoute
  '/run-job': typeof RunJobRoute
  '/run-workloads': typeof RunWorkloadsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/storage': typeof StorageRoute
  '/store': typeof StoreRoute
  '/system': typeof SystemRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/wallet': typeof WalletRoute
  '/admin/administrators': typeof AdminAdministratorsRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/credits': typeof AdminCreditsRoute
  '/admin/early-access': typeof AdminEarlyAccessRoute
  '/admin/instances': typeof AdminInstancesRoute
  '/admin/providers': typeof AdminProvidersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workspaces': typeof AdminWorkspacesRoute
  '/administrator/administrators': typeof AdministratorAdministratorsRoute
  '/administrator/approvals': typeof AdministratorApprovalsRoute
  '/administrator/audit': typeof AdministratorAuditRoute
  '/administrator/credits': typeof AdministratorCreditsRoute
  '/administrator/early-access': typeof AdministratorEarlyAccessRoute
  '/administrator/errors': typeof AdministratorErrorsRoute
  '/administrator/providers': typeof AdministratorProvidersRoute
  '/administrator/reports': typeof AdministratorReportsRoute
  '/administrator/settings': typeof AdministratorSettingsRoute
  '/administrator/users': typeof AdministratorUsersRoute
  '/administrator/workspaces': typeof AdministratorWorkspacesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/': typeof AdminIndexRoute
  '/administrator/': typeof AdministratorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/admin'
    | '/administrator'
    | '/alliancedao'
    | '/compute-resource-management'
    | '/connect'
    | '/crm'
    | '/device'
    | '/early-access'
    | '/email-verification'
    | '/finance'
    | '/login'
    | '/onboarding'
    | '/org'
    | '/password-reset'
    | '/pooled-compute'
    | '/privacy'
    | '/providers'
    | '/request-access'
    | '/run-job'
    | '/run-workloads'
    | '/settings'
    | '/signup'
    | '/storage'
    | '/store'
    | '/system'
    | '/terms-and-conditions'
    | '/wallet'
    | '/admin/administrators'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/credits'
    | '/admin/early-access'
    | '/admin/instances'
    | '/admin/providers'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/workspaces'
    | '/administrator/administrators'
    | '/administrator/approvals'
    | '/administrator/audit'
    | '/administrator/credits'
    | '/administrator/early-access'
    | '/administrator/errors'
    | '/administrator/providers'
    | '/administrator/reports'
    | '/administrator/settings'
    | '/administrator/users'
    | '/administrator/workspaces'
    | '/auth/callback'
    | '/admin/'
    | '/administrator/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/alliancedao'
    | '/compute-resource-management'
    | '/connect'
    | '/crm'
    | '/device'
    | '/early-access'
    | '/email-verification'
    | '/finance'
    | '/login'
    | '/onboarding'
    | '/org'
    | '/password-reset'
    | '/pooled-compute'
    | '/privacy'
    | '/providers'
    | '/request-access'
    | '/run-job'
    | '/run-workloads'
    | '/settings'
    | '/signup'
    | '/storage'
    | '/store'
    | '/system'
    | '/terms-and-conditions'
    | '/wallet'
    | '/admin/administrators'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/credits'
    | '/admin/early-access'
    | '/admin/instances'
    | '/admin/providers'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/workspaces'
    | '/administrator/administrators'
    | '/administrator/approvals'
    | '/administrator/audit'
    | '/administrator/credits'
    | '/administrator/early-access'
    | '/administrator/errors'
    | '/administrator/providers'
    | '/administrator/reports'
    | '/administrator/settings'
    | '/administrator/users'
    | '/administrator/workspaces'
    | '/auth/callback'
    | '/admin'
    | '/administrator'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/admin'
    | '/administrator'
    | '/alliancedao'
    | '/compute-resource-management'
    | '/connect'
    | '/crm'
    | '/device'
    | '/early-access'
    | '/email-verification'
    | '/finance'
    | '/login'
    | '/onboarding'
    | '/org'
    | '/password-reset'
    | '/pooled-compute'
    | '/privacy'
    | '/providers'
    | '/request-access'
    | '/run-job'
    | '/run-workloads'
    | '/settings'
    | '/signup'
    | '/storage'
    | '/store'
    | '/system'
    | '/terms-and-conditions'
    | '/wallet'
    | '/admin/administrators'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/credits'
    | '/admin/early-access'
    | '/admin/instances'
    | '/admin/providers'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/workspaces'
    | '/administrator/administrators'
    | '/administrator/approvals'
    | '/administrator/audit'
    | '/administrator/credits'
    | '/administrator/early-access'
    | '/administrator/errors'
    | '/administrator/providers'
    | '/administrator/reports'
    | '/administrator/settings'
    | '/administrator/users'
    | '/administrator/workspaces'
    | '/auth/callback'
    | '/admin/'
    | '/administrator/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRouteWithChildren
  AdministratorRoute: typeof AdministratorRouteWithChildren
  AlliancedaoRoute: typeof AlliancedaoRoute
  ComputeResourceManagementRoute: typeof ComputeResourceManagementRoute
  ConnectRoute: typeof ConnectRoute
  CrmRoute: typeof CrmRoute
  DeviceRoute: typeof DeviceRoute
  EarlyAccessRoute: typeof EarlyAccessRoute
  EmailVerificationRoute: typeof EmailVerificationRoute
  FinanceRoute: typeof FinanceRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  OrgRoute: typeof OrgRoute
  PasswordResetRoute: typeof PasswordResetRoute
  PooledComputeRoute: typeof PooledComputeRoute
  PrivacyRoute: typeof PrivacyRoute
  ProvidersRoute: typeof ProvidersRoute
  RequestAccessRoute: typeof RequestAccessRoute
  RunJobRoute: typeof RunJobRoute
  RunWorkloadsRoute: typeof RunWorkloadsRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  StorageRoute: typeof StorageRoute
  StoreRoute: typeof StoreRoute
  SystemRoute: typeof SystemRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  WalletRoute: typeof WalletRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage': {
      id: '/storage'
      path: '/storage'
      fullPath: '/storage'
      preLoaderRoute: typeof StorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/run-workloads': {
      id: '/run-workloads'
      path: '/run-workloads'
      fullPath: '/run-workloads'
      preLoaderRoute: typeof RunWorkloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/run-job': {
      id: '/run-job'
      path: '/run-job'
      fullPath: '/run-job'
      preLoaderRoute: typeof RunJobRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-access': {
      id: '/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof RequestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers': {
      id: '/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof ProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pooled-compute': {
      id: '/pooled-compute'
      path: '/pooled-compute'
      fullPath: '/pooled-compute'
      preLoaderRoute: typeof PooledComputeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-verification': {
      id: '/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof EmailVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-access': {
      id: '/early-access'
      path: '/early-access'
      fullPath: '/early-access'
      preLoaderRoute: typeof EarlyAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compute-resource-management': {
      id: '/compute-resource-management'
      path: '/compute-resource-management'
      fullPath: '/compute-resource-management'
      preLoaderRoute: typeof ComputeResourceManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alliancedao': {
      id: '/alliancedao'
      path: '/alliancedao'
      fullPath: '/alliancedao'
      preLoaderRoute: typeof AlliancedaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administrator': {
      id: '/administrator'
      path: '/administrator'
      fullPath: '/administrator'
      preLoaderRoute: typeof AdministratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administrator/': {
      id: '/administrator/'
      path: '/'
      fullPath: '/administrator/'
      preLoaderRoute: typeof AdministratorIndexRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administrator/workspaces': {
      id: '/administrator/workspaces'
      path: '/workspaces'
      fullPath: '/administrator/workspaces'
      preLoaderRoute: typeof AdministratorWorkspacesRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/users': {
      id: '/administrator/users'
      path: '/users'
      fullPath: '/administrator/users'
      preLoaderRoute: typeof AdministratorUsersRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/settings': {
      id: '/administrator/settings'
      path: '/settings'
      fullPath: '/administrator/settings'
      preLoaderRoute: typeof AdministratorSettingsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/reports': {
      id: '/administrator/reports'
      path: '/reports'
      fullPath: '/administrator/reports'
      preLoaderRoute: typeof AdministratorReportsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/providers': {
      id: '/administrator/providers'
      path: '/providers'
      fullPath: '/administrator/providers'
      preLoaderRoute: typeof AdministratorProvidersRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/errors': {
      id: '/administrator/errors'
      path: '/errors'
      fullPath: '/administrator/errors'
      preLoaderRoute: typeof AdministratorErrorsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/early-access': {
      id: '/administrator/early-access'
      path: '/early-access'
      fullPath: '/administrator/early-access'
      preLoaderRoute: typeof AdministratorEarlyAccessRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/credits': {
      id: '/administrator/credits'
      path: '/credits'
      fullPath: '/administrator/credits'
      preLoaderRoute: typeof AdministratorCreditsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/audit': {
      id: '/administrator/audit'
      path: '/audit'
      fullPath: '/administrator/audit'
      preLoaderRoute: typeof AdministratorAuditRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/approvals': {
      id: '/administrator/approvals'
      path: '/approvals'
      fullPath: '/administrator/approvals'
      preLoaderRoute: typeof AdministratorApprovalsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/administrator/administrators': {
      id: '/administrator/administrators'
      path: '/administrators'
      fullPath: '/administrator/administrators'
      preLoaderRoute: typeof AdministratorAdministratorsRouteImport
      parentRoute: typeof AdministratorRoute
    }
    '/admin/workspaces': {
      id: '/admin/workspaces'
      path: '/workspaces'
      fullPath: '/admin/workspaces'
      preLoaderRoute: typeof AdminWorkspacesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/providers': {
      id: '/admin/providers'
      path: '/providers'
      fullPath: '/admin/providers'
      preLoaderRoute: typeof AdminProvidersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/instances': {
      id: '/admin/instances'
      path: '/instances'
      fullPath: '/admin/instances'
      preLoaderRoute: typeof AdminInstancesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/early-access': {
      id: '/admin/early-access'
      path: '/early-access'
      fullPath: '/admin/early-access'
      preLoaderRoute: typeof AdminEarlyAccessRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/credits': {
      id: '/admin/credits'
      path: '/credits'
      fullPath: '/admin/credits'
      preLoaderRoute: typeof AdminCreditsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/approvals': {
      id: '/admin/approvals'
      path: '/approvals'
      fullPath: '/admin/approvals'
      preLoaderRoute: typeof AdminApprovalsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/administrators': {
      id: '/admin/administrators'
      path: '/administrators'
      fullPath: '/admin/administrators'
      preLoaderRoute: typeof AdminAdministratorsRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdministratorsRoute: typeof AdminAdministratorsRoute
  AdminApprovalsRoute: typeof AdminApprovalsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminCreditsRoute: typeof AdminCreditsRoute
  AdminEarlyAccessRoute: typeof AdminEarlyAccessRoute
  AdminInstancesRoute: typeof AdminInstancesRoute
  AdminProvidersRoute: typeof AdminProvidersRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWorkspacesRoute: typeof AdminWorkspacesRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdministratorsRoute: AdminAdministratorsRoute,
  AdminApprovalsRoute: AdminApprovalsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminCreditsRoute: AdminCreditsRoute,
  AdminEarlyAccessRoute: AdminEarlyAccessRoute,
  AdminInstancesRoute: AdminInstancesRoute,
  AdminProvidersRoute: AdminProvidersRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWorkspacesRoute: AdminWorkspacesRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AdministratorRouteChildren {
  AdministratorAdministratorsRoute: typeof AdministratorAdministratorsRoute
  AdministratorApprovalsRoute: typeof AdministratorApprovalsRoute
  AdministratorAuditRoute: typeof AdministratorAuditRoute
  AdministratorCreditsRoute: typeof AdministratorCreditsRoute
  AdministratorEarlyAccessRoute: typeof AdministratorEarlyAccessRoute
  AdministratorErrorsRoute: typeof AdministratorErrorsRoute
  AdministratorProvidersRoute: typeof AdministratorProvidersRoute
  AdministratorReportsRoute: typeof AdministratorReportsRoute
  AdministratorSettingsRoute: typeof AdministratorSettingsRoute
  AdministratorUsersRoute: typeof AdministratorUsersRoute
  AdministratorWorkspacesRoute: typeof AdministratorWorkspacesRoute
  AdministratorIndexRoute: typeof AdministratorIndexRoute
}

const AdministratorRouteChildren: AdministratorRouteChildren = {
  AdministratorAdministratorsRoute: AdministratorAdministratorsRoute,
  AdministratorApprovalsRoute: AdministratorApprovalsRoute,
  AdministratorAuditRoute: AdministratorAuditRoute,
  AdministratorCreditsRoute: AdministratorCreditsRoute,
  AdministratorEarlyAccessRoute: AdministratorEarlyAccessRoute,
  AdministratorErrorsRoute: AdministratorErrorsRoute,
  AdministratorProvidersRoute: AdministratorProvidersRoute,
  AdministratorReportsRoute: AdministratorReportsRoute,
  AdministratorSettingsRoute: AdministratorSettingsRoute,
  AdministratorUsersRoute: AdministratorUsersRoute,
  AdministratorWorkspacesRoute: AdministratorWorkspacesRoute,
  AdministratorIndexRoute: AdministratorIndexRoute,
}

const AdministratorRouteWithChildren = AdministratorRoute._addFileChildren(
  AdministratorRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRouteWithChildren,
  AdministratorRoute: AdministratorRouteWithChildren,
  AlliancedaoRoute: AlliancedaoRoute,
  ComputeResourceManagementRoute: ComputeResourceManagementRoute,
  ConnectRoute: ConnectRoute,
  CrmRoute: CrmRoute,
  DeviceRoute: DeviceRoute,
  EarlyAccessRoute: EarlyAccessRoute,
  EmailVerificationRoute: EmailVerificationRoute,
  FinanceRoute: FinanceRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  OrgRoute: OrgRoute,
  PasswordResetRoute: PasswordResetRoute,
  PooledComputeRoute: PooledComputeRoute,
  PrivacyRoute: PrivacyRoute,
  ProvidersRoute: ProvidersRoute,
  RequestAccessRoute: RequestAccessRoute,
  RunJobRoute: RunJobRoute,
  RunWorkloadsRoute: RunWorkloadsRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  StorageRoute: StorageRoute,
  StoreRoute: StoreRoute,
  SystemRoute: SystemRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  WalletRoute: WalletRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
